import { buildSelectionSwitchBlock } from './demoSelectionSwitch.js'
import { buildWorkflowTimeline } from '../streaming/buildWorkflowTimeline.js'

/** Demo copy for the NexusB2B Google Cloud deployment thread. */

export const GCP_HOSTING_USER_PROMPT =
  'This is excellent, Can you host it on Google cloud'

export const GCP_HOSTING_WORKED_LABEL = 'Worked for 14m 22s'

export const GCP_HOSTING_THOUGHT_DETAILS = [
  `The user wants **NexusB2B** hosted on Google Cloud. I'll deploy the full stack — *React frontend*, *FastAPI backend*, *Cloud SQL PostgreSQL*, load balancer, and custom domain with HTTPS.`,
  `**Plan:** nine phases from GCP project setup through production handoff. I'll stream status dashboards after each milestone so they can see exactly what's ready.`,
  `Google Cloud is already connected in their workspace — *starting Phase 1 now*.`,
]

export const GCP_HOSTING_PLAN_MARKDOWN = `I'm going to deploy your **full-stack B2B application** on Google Cloud.

**What you will get:**
- **React frontend** — modern procurement website
- **Python backend** — FastAPI with JWT auth and deal management
- **Secure PostgreSQL database** — private Cloud SQL instance
- **Custom domain** — e.g. \`app.yourcompany.com\`
- **HTTPS + WAF** — managed SSL and Cloud Armor protection

**Total estimated time:** *50–80 minutes*  
**Estimated monthly cost:** *$35 – $65* (depending on usage)

I will do everything step by step and keep you updated.`

export const GCP_HOSTING_GCP_APP_BLOCK = {
  type: 'appConnection',
  title: 'Google Cloud',
  description: 'Application is already connected. Ready to provision NexusB2B infrastructure.',
  iconUrl: 'https://cdn.simpleicons.org/googlecloud/4285F4',
  status: 'connected',
  toolkitSlug: 'google-cloud',
  tags: ['OAuth2', 'Cloud Run'],
}

export const PROJECT_ID = 'nexus-b2b-prod-48291'
export const BACKEND_URL = 'https://bizlink-backend-a8f2c.run.app'
export const LIVE_URL = 'https://app.nexusb2b.com'

/** @typedef {{ Component: string, Status: string, Details: string }} GcpStatusRow */

/** @param {GcpStatusRow[]} rows @returns {object} */
export function statusTable(rows) {
  return { type: 'table', data: rows }
}

export function buildPhaseStartBlocks(n, title, doing, why, eta) {
  const blocks = [
    { type: 'heading', level: 3, content: `Phase ${n} of 9: ${title}` },
    { type: 'markdown', content: `**What I'm doing:**\n\n${doing}` },
    { type: 'markdown', content: `**Why:** *${why}*` },
  ]
  if (eta) {
    blocks.push({ type: 'markdown', content: `⏳ *${eta}*` })
  }
  return blocks
}

/** @param {string} label @param {GcpStatusRow[]} table @param {string} [readyFor] */
